import React, { useState } from "react";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

const NOCShortfallLog = ({ shortfallData }) => {
  // Convert object to array for easier mapping
  const dataArray = Object.entries(shortfallData || {});
  const [docUrl, setDocUrl] = useState(null);

  const handleView = (url) => {
    // Open the document in a new tab
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // Helper to extract date and time from key
  const extractDateTime = (key) => {
    // Example key: objection_2025-09-26_13-58-11-645
    const match = key.match(/_(\d{4}-\d{2}-\d{2})_(\d{2}-\d{2}-\d{2})/);
    if (match) {
      const [_, date, time] = match;
      // Format time as HH:MM:SS
      const formattedTime = time.replace(/-/g, ":");
      return { date, time: formattedTime };
    }
    return { date: "-", time: "-" };
  };

  return (
    <div>
      <div style={{ marginBottom: "10px" }}>
        <h3 style={{ fontWeight: "bold", margin: 0 }}>Shortfall Log</h3>
      </div>
      <div style={{ overflowX: "auto", maxHeight: "300px", overflowY: "scroll" }}>
        <table
          border="1"
          cellPadding="8"
          width="100%"
          style={{
            borderCollapse: "collapse",
            minWidth: "500px",
            fontSize: "12px",
            position: "relative",
          }}
        >
          <thead style={{ backgroundColor: "rgba(52, 73, 94, 0.94)", position: "sticky", top: 0, zIndex: 2 }}>
            <tr style={{ fontSize: "14px", backgroundColor: "rgba(52, 73, 94, 0.94)", color: "#fff" }}>
              <th>Sr. No.</th>
              <th>Shortfall</th>
              <th>Date</th>
              <th>Time</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {dataArray.length === 0 ? (
              <tr>
                <td colSpan={5} align="center">
                  No Shortfall Data Available
                </td>
              </tr>
            ) : (
              dataArray.map(([key, value], idx) => {
                // value is an object with one key-value pair: { shortfallKey: url }

                const { date, time } = extractDateTime(key);
                return (
                  <tr key={key}>
                    <td>{idx + 1}</td>
                    <td>{`Shortfall ${idx + 1}`}</td>
                    <td>{date}</td>
                    <td>{time}</td>
                    <td>
                      {value ? (
                        <IconButton onClick={() => handleView(value)} size="small" title="View Document">
                          <VisibilityIcon fontSize="small" style={{ color: "#157CB3" }} />
                        </IconButton>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NOCShortfallLog;
